<template>
  <div class="products row">
    <order-item v-for="product in items" v-bind:key="product.id"  v-bind:product="product"></order-item>
  </div>
</template>

<script>
  import orderItem from './order-item.vue';

  export default {
    name: 'order-list',
    components: {  orderItem },
    props: {
      'items': {}
    },
  
    updated: function () {

      $(document).trigger('vue-items-loaded');
           
      this.$nextTick(function () {
        //var windowWidth = $(window).width();
        //if (windowWidth < 1024) {
        //  $('#orderController .col-products').getNiceScroll().hide()
        //  console.log('reverting to html scroll');
        //}
        //else {
        //  $('#orderController .col-products').getNiceScroll().show();
        //  $('#orderController .col-products').getNiceScroll().resize();
        //}
        var niceColProd = $('#orderController .col-products .nice-scroll').getNiceScroll(0);

        if (niceColProd) {
          niceColProd.resize();
          niceColProd.doScrollTop(0, 300);
        }
        
        // scroll product list (whole page) to top
        $('html').scrollTop(0);

        // scroll product list (whole page) to top
        var nicescroll = $('#orderController .col-products .nice-scroll').getNiceScroll(0);
        if (niceColProd) {
          nicescroll.doScrollTop(0, 300);
        } else {
          //$('#orderController .col-products .nice-scroll').scrollTop(0);
          $('#orderController .col-products .nice-scroll').animate({ scrollTop: '0' });
        }
        

        //$('html').getNiceScroll().resize();
        //$('body').getNiceScroll().resize();
      })
    }
  }


</script>



// WEBPACK FOOTER //
// Vue/Src/Components/order-list.vue